import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=0da3bbee&scoped=true&"
import script from "./bottomNav.vue?vue&type=script&lang=js&"
export * from "./bottomNav.vue?vue&type=script&lang=js&"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=0da3bbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3bbee",
  null
  
)

export default component.exports